import { SupportType } from "../enums/supportType.enum";

export class SupportDto {
  name: SupportType = SupportType.choose;
  email!: string;
  message!: string;
}
